import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", company: "" });
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  function update(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setStatus("");
    try {
      await api.post("/api/support/requests", form);
      setForm({ name: "", email: "", subject: "", message: "", company: "" });
      setStatus("Thanks — your request is in the OmniMark admin inbox. We’ll reply to the email you provided.");
    } catch (error) {
      setStatus(error?.response?.data?.detail || "We couldn’t send your request. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <main className="mx-auto max-w-3xl px-4 py-10">
        <Link to="/" className="text-violet-400 hover:underline">← Back</Link>
        
        <h1 className="text-4xl font-bold mt-6 mb-4">Contact</h1>

        <div className="prose prose-invert max-w-none space-y-6 text-white/70">
          <p>
            OmniMark HQ is owned and operated by Nichols Global Business Services, LLC.
          </p>
          <p>For support, billing questions, or partnerships, send a request directly to the OmniMark admin team.</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4 rounded-2xl border border-white/10 bg-white/5 p-6">
          <div className="grid gap-4 sm:grid-cols-2">
            <label className="grid gap-1 text-sm">Your name
              <input required value={form.name} onChange={(e) => update("name", e.target.value)} className="rounded-lg bg-black/30 p-3 text-white" maxLength="120" />
            </label>
            <label className="grid gap-1 text-sm">Reply email
              <input required type="email" value={form.email} onChange={(e) => update("email", e.target.value)} className="rounded-lg bg-black/30 p-3 text-white" maxLength="254" />
            </label>
          </div>
          <label className="grid gap-1 text-sm">Subject
            <input required value={form.subject} onChange={(e) => update("subject", e.target.value)} className="rounded-lg bg-black/30 p-3 text-white" maxLength="180" />
          </label>
          <label className="grid gap-1 text-sm">How can we help?
            <textarea required value={form.message} onChange={(e) => update("message", e.target.value)} className="min-h-36 rounded-lg bg-black/30 p-3 text-white" minLength="10" maxLength="5000" />
          </label>
          <input aria-hidden="true" tabIndex="-1" autoComplete="off" value={form.company} onChange={(e) => update("company", e.target.value)} className="hidden" />
          <button disabled={busy} className="rounded-lg bg-violet-600 px-5 py-3 font-semibold disabled:opacity-50">{busy ? "Sending…" : "Send to OmniMark admin"}</button>
          {status && <p role="status" className="text-sm text-white/80">{status}</p>}
        </form>
      </main>
    </div>
  );
}
